import { postJson } from "../methods";
function newPassword(payload) {
  const { token, ...withoutToken } = payload;
  return postJson({
    url: `/backend/auth/password_reset/new_password?token=${token}`,
    payload: withoutToken
  });
}
export {
  newPassword
};
